import { render, staticRenderFns } from "./AdminPageBlocksComponent.vue?vue&type=template&id=2be18520"
import script from "./AdminPageBlocksComponent.vue?vue&type=script&lang=js"
export * from "./AdminPageBlocksComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports